import { FileDocumentIcon, VideoFileIcon } from "@flat-ui";

export const fileIcons: {
  [key: string]: React.ElementType;
} = {
  pdf: FileDocumentIcon,
  txt: FileDocumentIcon,
  xls: FileDocumentIcon,
  xlsx: FileDocumentIcon,
  mp4: VideoFileIcon,
  default: FileDocumentIcon,
};
